export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FORGOT_PASSWORD_EMAIL_SUCCESS = 'FORGOT_PASSWORD_EMAIL_SUCCESS';
export const RESET_USER_PROFILE = 'RESET_USER_PROFILE';
export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS';
export const SET_GENERAL_PARAMETERS = 'SET_GENERAL_PARAMETERS';
